"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userFreeText = exports.UserFreeTextController = void 0;
var UserFreeTextController = /** @class */ (function () {
    /* @ngInject */
    function UserFreeTextController() {
        //Prevent typeScript empty block error.
    }
    UserFreeTextController.prototype.$onInit = function () {
        /**/
    };
    UserFreeTextController.prototype.getText = function () {
        return this.userFreeText || this.translation;
    };
    return UserFreeTextController;
}());
exports.UserFreeTextController = UserFreeTextController;
exports.userFreeText = {
    template: "<span data-hook=\"user-free-text\" class=\"user-free-text\">{{userFreeTextVM.getText()}}</span>",
    controller: UserFreeTextController,
    controllerAs: 'userFreeTextVM',
    bindings: {
        userFreeText: '=',
        translation: '=',
    },
};
